<template>
  <v-stepper
    v-model="passoAtual"
    class="mt-2 mt-md-5"
    style="box-shadow: none;"
  >
    <v-stepper-header
      class="grey lighten-3"
      style="box-shadow: none;"
    >
      <template v-for="(item, index) in quantDePassos">
        <v-stepper-step
          :key="'step_' + index"
          :step="item.step"
          :complete="passoAtual > item.step"
          complete-icon="check"
          :data-cy="'passo_marcador_' + item.step"
        />

        <v-divider
          v-if="quantDePassos.length > item.step"
          :key="'divider_' + index"
        />
      </template>
    </v-stepper-header>

    <v-stepper-items
      class="grey lighten-3"
    >
      <template v-for="(item, index) in quantDePassos">
        <v-stepper-content
          :key="'content_' + index"
          :step="item.step"
          :class="$vuetify.breakpoint.smAndDown ? 'height-content' : 'padding-b'"
          class="pa-0"
        >
          <PassoDadosCompra v-if="item.step === 1" />
          <PassoSobreReembolso
            v-if="item.step === 2"
            class="pb-md-5"
            @formValidado="ativarPasso($event,index)"
          />

          <div
            :class="$vuetify.breakpoint.mdAndUp
              ? 'botoes-rodape--desktop' : 'botoes-rodape--mobile botoes-rodape--stepper'"
            class="botoes-rodape --reembolso pa-3 pa-md-0 px-md-0"
          >
            <BtnVoltar
              :key="'voltar_' + index"
              :index="item.step"
              @irParaAnterior="novoValor => passoAtual = novoValor"
            />

            <BtnProsseguir
              v-if="item.step < 2"
              :key="'prosseguir_' + index"
              :index="item.step"
              :desabilitar-btn="item.possuiValidacao && !item.validado"
              @irParaProximo="novoValor => passoAtual = novoValor"
            />

            <BtnEnviar
              v-else
              :dados-reembolso="dadosReembolso"
              :anexos="anexos"
              :desabilitar-btn="item.possuiValidacao && !item.validado"
              @respostaApi="showModal"
            />

            <ModalSolicitarReembolso
              v-if="item.step === 2"
              :dialog="dialog"
              :resposta-success="respostaApi"
              :produtor="nomeProdutor"
            />
          </div>
        </v-stepper-content>
      </template>
    </v-stepper-items>
  </v-stepper>
</template>

<script>

import { mapGetters } from 'vuex';
import PassoDadosCompra from '@/components/SolicitacaoReembolso/PassoDadosCompra.vue';
import PassoSobreReembolso from '@/components/SolicitacaoReembolso/PassoSobreReembolso.vue';
import BtnProsseguir from '@/components/Steppers/BtnProsseguir.vue';
import BtnEnviar from '@/components/SolicitacaoReembolso/BtnEnviar.vue';
import BtnVoltar from '@/components/Steppers/BtnVoltar.vue';
import ModalSolicitarReembolso from '@/components/SolicitacaoReembolso/ModalSolicitarReembolso.vue';

export default {
  name: 'CartaoStepper',

  components: {
    PassoDadosCompra,
    PassoSobreReembolso,
    BtnProsseguir,
    BtnEnviar,
    BtnVoltar,
    ModalSolicitarReembolso,
  },

  data() {
    return {
      passoAtual: 1,
      btAtualDisabled: true,
      dadosReembolso: {
        venda: null,
        is_boleto: null,
        category_reembolso: null,
        observacoes: null,
        is_credit_card: null,
      },
      dialog: false,
      respostaApi: false,
      nomeProdutor: '',
      anexos: [],
      dadosVenda: {
        venda: '',
        is_credit_card: '',
        is_boleto: '',
        category_reembolso: '',
      },
      quantDePassos: [
        {
          step: 1,
          form: {},
          possuiValidacao: false,
          validado: false,
        },
        {
          step: 2,
          form: {},
          possuiValidacao: true,
          validado: false,
        },
      ],
    };
  },

  computed: {
    ...mapGetters(['dadosCompra']),
  },

  watch: {
    passoAtual() {
      this.montarObjeto();
    },
    quantDePassos: {
      handler() {
        this.montarObjeto();
      },
      deep: true,
    },
  },

  mounted() {
    this.setDadosVenda();
    this.nomeProdutor = this.dadosCompra.vendedor || '';
  },

  methods: {
    setDadosVenda() {
      this.dadosVenda.venda = `${this.dadosCompra.venda}`;
      this.dadosVenda.is_credit_card = this.dadosCompra.cartaoCredito;
      this.dadosVenda.is_boleto = this.dadosCompra.boleto;
      this.dadosVenda.category_reembolso = this.dadosCompra.category;
      this.quantDePassos[0].form = this.dadosVenda;
    },

    ativarPasso(dadosForm, indexArray) {
      this.quantDePassos[indexArray].validado = dadosForm.validado;
      this.quantDePassos[indexArray].form = dadosForm.form;
    },

    montarObjeto() {
      if (this.passoAtual === 2 && this.quantDePassos[1].validado) {
        const passoUm = this.quantDePassos[0].form;
        const passoDois = this.quantDePassos[1].form;
        Object.assign(this.dadosReembolso, passoUm, passoDois);
        this.anexos = passoDois.anexos;
      }
    },

    showModal(resposta) {
      this.dialog = true;
      this.respostaApi = resposta;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/scss/botoes-fixos.scss';
</style>
